import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#4E575F', // Primary color (used in AppBar, etc.)
        },
        secondary: {
            main: '#ffffff',
        },
        background: {
            default: '#f9f9f9',
        },
        text: {
            primary: '#333333',
        },
    },
    typography: {
        fontFamily: "'Roboto', sans-serif",
    },
});

export default theme;
